import {
  PATH_NAME_ADULT_DOWNLOAD_INFORMATION_POPUP,
  PATH_NAME_ADULT_INFORMATION_POPUP,
  PATH_NAME_DOWNLOAD_PINCODE_CHECK, PATH_NAME_DOWNLOAD_PINCODE_COMPLETE,
  PATH_NAME_PINCODE_CHECK,
  PATH_NAME_PINCODE_COMPLETE
} from '@/common/resources/router.const'
import { ADULT_CHECK_TYPE_CONTENT, ADULT_CHECK_TYPE_DOWNLOAD } from '@/common/resources/const'

export default [
  {
    path: '/setting/adult_information_popup',
    name: PATH_NAME_ADULT_INFORMATION_POPUP,
    alias: '/setting/adult_information_popup.html',
    meta: { type: ADULT_CHECK_TYPE_CONTENT },
    components: {
      adult: () => import('@/components/adult/AdultVerificationInformationPopup')
    }
  },
  {
    path: '/setting/download/adult_information_popup',
    name: PATH_NAME_ADULT_DOWNLOAD_INFORMATION_POPUP,
    alias: '/setting/adult_information_popup.html',
    meta: { type: ADULT_CHECK_TYPE_DOWNLOAD },
    components: {
      adult: () => import('@/components/adult/AdultVerificationInformationPopup')
    }
  },
  {
    path: '/setting/pincode_check',
    name: PATH_NAME_PINCODE_CHECK,
    alias: '/setting/pincode_check.html',
    meta: { type: ADULT_CHECK_TYPE_CONTENT },
    components: {
      adult: () => import('@/components/adult/PinCodeCheck')
    }
  },
  {
    path: '/setting/download/pincode_check',
    name: PATH_NAME_DOWNLOAD_PINCODE_CHECK,
    alias: '/setting/download/pincode_check.html',
    meta: { type: ADULT_CHECK_TYPE_DOWNLOAD },
    components: {
      adult: () => import('@/components/adult/PinCodeCheck')
    }
  },
  {
    path: '/setting/pincode_check/complete',
    name: PATH_NAME_PINCODE_COMPLETE,
    alias: '/setting/pincode_check/complete.html',
    meta: { type: ADULT_CHECK_TYPE_CONTENT },
    components: {
      adult: () => import('@/components/adult/PinCodeComplete')
    }
  },
  {
    path: '/setting/download/pincode_check/complete',
    name: PATH_NAME_DOWNLOAD_PINCODE_COMPLETE,
    alias: '/setting/download/pincode_check/complete.html',
    meta: { type: ADULT_CHECK_TYPE_DOWNLOAD },
    components: {
      adult: () => import('@/components/adult/PinCodeComplete')
    }
  }
]
